// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-card {
  width: 250px;
  height: 300px;
  border: 1px solid black;
}

.article-card__content__author-bar {
  display: flex;
  justify-content: space-around;
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/article-card/article-card.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B","sourcesContent":[".article-card {\n  width: 250px;\n  height: 300px;\n  border: 1px solid black;\n}\n\n.article-card__content__author-bar {\n  display: flex;\n  justify-content: space-around;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
